// src/pages/Orders/Orders.js

import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import { AuthContext } from "../../context/AuthContext";
import config from "../../config";
import "./Orders.css";

const Orders = () => {
  const { user } = useContext(AuthContext);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const fetchOrders = async () => {
    if (!user?.userID) return;

    try {
      setLoading(true);
      setError("");

      // GET /api/restaurants/foodorders/:userID, passing userID as well
      const { data } = await axios.get(
        `${config.apiBaseUrl}/api/restaurants/foodorders/${user.userID}`,
        {
          params: { userID: user.userID },
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );
      setOrders(data || []);
    } catch (err) {
      console.error("[Orders] Error fetching orders:", err);
      setError("Failed to fetch orders. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, [user]);

  return (
    <div className="orders-container">
      <h1 className="orders-title">My Orders</h1>

      {/* Loading / Error States */}
      {loading && <div>Loading your orders...</div>}
      {!loading && error && <div className="orders-error">{error}</div>}

      {/* No Orders */}
      {!loading && !error && orders.length === 0 && (
        <div className="no-orders">You don’t have any orders yet.</div>
      )}

      {/* Orders List */}
      {!loading && !error && orders.length > 0 && (
        <div className="orders-list">
          {orders.map((order) => (
            <div key={order.orderID} className="order-card">
              <h2>Order Number: #{order.orderID}</h2>
              <div className="order-details">
                <p>
                  <strong>Restaurant:</strong>{" "}
                  {order.restaurantName || "N/A"}
                </p>
                <p>
                  <strong>Status:</strong>{" "}
                  {order.orderStatus || "N/A"}
                </p>

                <p><strong>Items:</strong></p>
                <ul>
                  {order.cartItems?.map((item) => (
                    <li key={item.id}>
                      {/* e.g. "Pasta Pomodoro (3) - $30" */}
                      {item.name} ({item.quantity}) - $
                      {(item.price * item.quantity).toFixed(2)}
                    </li>
                  ))}
                </ul>

                <p>
                  <strong>Total:</strong> $
                  {order.totalAmount?.toFixed(2)}
                </p>
                <p>
                  <strong>Ordered On:</strong>{" "}
                  {new Date(order.createdAt).toLocaleString()}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Orders;
